/**
 * Created by nijin on 17/2/17.
 */
import {Component, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {FormGroup, Validators, FormBuilder} from '@angular/forms';
import {GlobalValidator} from '../../shared/validators/global-validator';
import {ThingsService} from '../things.service';

@Component({
    selector: 'nuc-clone-popup',
    templateUrl: './clone-popup.html',
    styleUrls: ['./clone-popup.component.scss']
})
export class  ClonePopupComponent implements OnInit {

   @ViewChild ('popup') popup;
   @ViewChild ('cloneCount') textboxElement;
  formErrors = {
    'cloneCount': ''
  };
  validationMessages = {
    'cloneCount': {
      'required':  'THING_DETAILS.VALIDATIONS.NUMBER_REQUIRED',
      'invalidRange': 'THING_DETAILS.VALIDATIONS.INVALID_RANGE',
    }
  };

   @Input() selectedThing;
   isSubmitted: boolean;
     cloneForm: FormGroup;
     isLoading  = false;
    @Output() successSubmit: EventEmitter<any> = new EventEmitter<any>();
    constructor(private fb: FormBuilder,
                private thingsService: ThingsService) { }

  ngOnInit() {
      this.buildForm();
  }

  get name() {
      return this.selectedThing ? this.selectedThing['name'] : '';
  }

    buildForm() {
      this.cloneForm = this.fb.group({
        'cloneCount': ['', [
          Validators.required,
          GlobalValidator.numberBetween(1, 50)
        ]]
      });
      this.cloneForm.valueChanges
        .subscribe((data) => {this.onValueChanged(data); });
      this.onValueChanged();
    }
    open() {
      this.popup.open();
      // this.textboxElement.nativeElement.focus();
    }
    close() {
      this.popup.hide();
      this.cloneForm.reset();
    }

    submit(form) {
      this.isSubmitted = true;
      this.onValueChanged();
      if (!form.valid || !this.selectedThing) {
        return;
      }
      this.isLoading = true;
      this.thingsService.clone(this.cloneForm.controls['cloneCount'].value, this.selectedThing['token'])
          .subscribe((response) => {
             this.isSubmitted = false;
             this.isLoading = false;
              this.successSubmit.emit(response);
              this.close();
          }, (error) => { this.isLoading = false; });

    }

  onValueChanged(data?: any) {
    if (!this.cloneForm) { return; }
    const form = this.cloneForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (!control.valid)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          if (control.errors.hasOwnProperty(key)) {
            this.formErrors[field] = messages[key];
          }
        }
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/things/shared/clone-popup.component.ts